var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"join-wrap"},[_c('div',{staticClass:"join-img"}),_c('Core'),_c('Mission'),_c('div',{attrs:{"id":"join"}},[_c('Join')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }